import { Component, Input, OnInit } from '@angular/core';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LedgersService } from 'src/app/share/services/ledgers/ledgers.service';
import { DownloadService } from 'src/app/share/services/download.service';

@Component({
    selector: 'app-dealer-stop-buying',
    templateUrl: './dealer-stop-buying.component.html',
    styleUrls: ['./dealer-stop-buying.component.scss'],
    standalone: false
})
export class DealerStopBuyingComponent implements OnInit {

  @Input() selectedTyre: any;

  faAngleRight = faAngleRight;

  dealers: any = [];
  displayedDealers: any = [];
  limit = 5;
  loader: boolean = false;
  errorMessage: string = '';

  constructor(
    private readonly modalService: NgbModal,
    private readonly ledgersService: LedgersService,
    private readonly downloadService: DownloadService,
  ) { }


  ngOnInit(): void {
    this.getDealersdata();
  }

  getDealersdata() {
    this.displayedDealers = []
    this.dealers = []
    this.loader = true;
    let payload = {
      tyreSize: this.selectedTyre.tyreSize,
      tyreMake: this.selectedTyre.tyreMake,
      tyreModel: this.selectedTyre.tyreModel,
    }
    this.ledgersService.getDealersStopBuying(payload).subscribe({
      next: (res: any) => {
        if (res.data.length) {
          this.responseMapping(res.data)
        } else {
          this.loader = false;
          this.errorMessage = 'No history found for this  filter';
        }
      },
      error: (err: any) => {
        this.loader = false;
        this.errorMessage = err.error.message || 'Something went wrong';
      }
    })
  }

  responseMapping(data: any) {
    this.dealers = data.map((item: any) => ({
      dealerName: item.dealer?.name?.trim() || '',
      quantity: Number.isNaN(Number(item.quantity)) ? 0 : Number(item.quantity),
      unitPrice: Number.isNaN(Number(item.unitPrice)) ? 0 : Number(item.unitPrice),
      daysSinceLastBuy: Number.isNaN(Number(item.daysSinceLastBuy)) ? 0 : Number(item.daysSinceLastBuy),
      date: item.lastBuy
        ? new Date(item.lastBuy).toLocaleDateString('en-GB', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
          timeZone: 'Asia/Kolkata'
        })
        : ''
    }));
    this.displayedDealers = this.dealers.slice(0, this.limit);
    this.loader = false;
  }

  viewMore(content: any): void {
    this.modalService.open(content, { size: 'lg', scrollable: true, centered: true });
  }

  exportCSV() {
    let payload = {
      tyreSize: this.selectedTyre.tyreSize,
      tyreMake: this.selectedTyre.tyreMake,
      tyreModel: this.selectedTyre.tyreModel,
    }
    const filename = `${this.selectedTyre.tyreSize}_${this.selectedTyre.tyreMake}_${this.selectedTyre.tyreModel}_dealers_who_stop_buying.csv`;
    const request: any = this.ledgersService.getDealerStopBuyingCSV(payload);
    this.downloadService.download(request, filename);
  }

}
